import {Hash} from "../../../interfaces/hashInterfaces";
import {formulaFunctions} from "../../../formulaFunctions";
import DynamicFieldsHandler from "./dynamicFieldsHandler";
import {IDynamicFieldsElementOptions} from "../../../interfaces/dynamicFieldsElementOptionsInterfaces";
import {IFormulaSelector} from "../../../interfaces/formulaInterfaces";

export default class FormulaFunctionsDynamicFieldsHandler extends DynamicFieldsHandler {
  SECTIONS = ['formulaBuilderFunctions'];
  dynamicMessage: string;
  showDynamicMessage: boolean;
  elementOptions: IDynamicFieldsElementOptions;

  constructor(options: Hash = {}) {
    super(options);
  }

  formulaFunctions(q: string) {
    return formulaFunctions.filter(formFunc => {
      return formFunc.name.toLowerCase().match(q) || formFunc.description.toLowerCase().match(q);
    });
  }

  hasFormulaMatch(q: string) {
    return Object.keys(this.formulaFunctions(q)).length > 0
  }

  formulaSections(q: string): IFormulaSelector {
    const sections: IFormulaSelector = {
      math: {displayName: 'Math', functions: {}, select: this.selectFormula.bind(this)},
      string: {displayName: 'String', functions: {}, select: this.selectFormula.bind(this)},
      datetime: {displayName: 'Date/Time', functions: {}, select: this.selectFormula.bind(this)},
      logical: {displayName: 'Logical', functions: {}, select: this.selectFormula.bind(this)},
    };
    this.formulaFunctions(q).forEach(func => {
      sections[func.type].functions[func.name] = {
        description: func.description,
        args: func.args,
      };
    });
    return sections;
  }

  selectFormula(name: string): string {
    return name;
  }
}